export const getBanners = () => ({
  type: "@saga/GET_BANNERS",
});
